<template>
  <div class="d-flex flex-column flex-root">
    <!--begin::Page-->
    <div class="page d-flex flex-row flex-column-fluid">
      <!--begin::Aside-->
      <!--end::Aside-->
      <!--begin::Wrapper-->
      <div class="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper">
        <!--begin::Header-->
        <div id="kt_header" class="header">
          <!--begin::Container-->
          <div
              class="container-fluid d-flex align-items-center flex-wrap justify-content-between"
              id="kt_header_container"
          >
            <!--begin::Page title-->
            <div
                class="page-title d-flex flex-column align-items-start justify-content-center flex-wrap me-2 pb-5 pb-lg-0 pt-7 pt-lg-0"
                data-kt-swapper="true"
                data-kt-swapper-mode="prepend"
                data-kt-swapper-parent="{default: '#kt_content_container', lg: '#kt_header_container'}"
            >
              <!--begin::Heading-->
              <h1 class="d-flex flex-column text-dark fw-bolder my-0">
                Lịch sử trả xu
                <small class="text-muted fs-6 fw-bold ms-1 pt-1"
                >Số lượng {{ $numberFormat(items.lenght) }}</small
                >
              </h1>
              <!--end::Heading-->
            </div>
            <!--end::Page title=-->
            <!--begin::Wrapper-->
            <div class="d-flex d-lg-none align-items-center ms-n3 me-2">
              <!--begin::Aside mobile toggle-->
              <div
                  class="btn btn-icon btn-active-icon-primary"
                  id="kt_aside_toggle"
              >
                <!--begin::Svg Icon | path: icons/duotune/abstract/abs015.svg-->
                <span class="svg-icon svg-icon-1 mt-1">
                  <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                  >
                    <path
                        d="M21 7H3C2.4 7 2 6.6 2 6V4C2 3.4 2.4 3 3 3H21C21.6 3 22 3.4 22 4V6C22 6.6 21.6 7 21 7Z"
                        fill="black"
                    />
                    <path
                        opacity="0.3"
                        d="M21 14H3C2.4 14 2 13.6 2 13V11C2 10.4 2.4 10 3 10H21C21.6 10 22 10.4 22 11V13C22 13.6 21.6 14 21 14ZM22 20V18C22 17.4 21.6 17 21 17H3C2.4 17 2 17.4 2 18V20C2 20.6 2.4 21 3 21H21C21.6 21 22 20.6 22 20Z"
                        fill="black"
                    />
                  </svg>
                </span>
                <!--end::Svg Icon-->
              </div>
              <!--end::Aside mobile toggle-->
            </div>
            <!--end::Wrapper-->
          </div>
          <!--end::Container-->
        </div>
        <!--end::Header-->
        <!--begin::Content-->
        <div
            class="content d-flex flex-column flex-column-fluid"
            id="kt_content"
        >
          <!--begin::Container-->
          <div class="container-fluid" id="kt_content_container">
            <!--begin::Row-->
            <div class="row g-5 g-lg-10">
              <div class="card card-flush">
                <div class="card-header align-items-center py-5 gap-2 gap-md-5">
                  <!--begin::Card title-->
                  <div class="card-title">
                    <select v-model="selectedDay" @change="fetchItems()" class="form-control">
                      <option v-for="day in last10Days" :key="day" :value="day">
                        {{ day }}
                      </option>
                    </select>
                  </div>
                  <!--end::Card title-->
                </div>
                <!--begin::Card body-->
                <div class="card-body pt-0">
                  <!--begin::Table-->
                  <div
                      id="kt_ecommerce_category_table_wrapper"
                      class="dataTables_wrapper dt-bootstrap4 no-footer"
                  >
                    <div class="table-responsive">
                      <table
                          class="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer"
                          id="kt_ecommerce_category_table"
                      >
                        <!--begin::Table head-->
                        <thead>
                        <!--begin::Table row-->
                        <tr
                            class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0"
                        >
                          <th
                              tabindex="0"
                              aria-controls="kt_ecommerce_category_table"
                              rowspan="1"
                              colspan="1"
                              aria-label="Category: activate to sort column ascending"
                          >
                            Id
                          </th>
                          <th
                              tabindex="0"
                              aria-controls="kt_ecommerce_category_table"
                              rowspan="1"
                              colspan="1"
                              aria-label="Category Type: activate to sort column ascending"
                          >
                            Tác giả
                          </th>
                          <th
                              tabindex="0"
                              aria-controls="kt_ecommerce_category_table"
                              rowspan="1"
                              colspan="1"
                              aria-label="Category Type: activate to sort column ascending"
                          >
                            Giá
                          </th>
                          <th
                              tabindex="0"
                              aria-controls="kt_ecommerce_category_table"
                              rowspan="1"
                              colspan="1"
                              aria-label="Category Type: activate to sort column ascending"
                          >
                            Xu
                          </th>
                          <th
                              tabindex="0"
                              aria-controls="kt_ecommerce_category_table"
                              rowspan="1"
                              colspan="1"
                              aria-label="Category Type: activate to sort column ascending"
                          >
                            Thời gian
                          </th>
                        </tr>
                        <!--end::Table row-->
                        </thead>
                        <!--end::Table head-->
                        <!--begin::Table body-->
                        <tbody class="fw-bold text-gray-600">
                        <tr v-for="item in this.items.data" :key="item.id">
                          <td>{{ item.id }}</td>
                          <td>
                            <a v-if="item.author" :href="$webUrl('tac-gia', item.author.nameSearch, item.author.id)"
                               target="_blank">
                              <AuthorCard :author="item.author"/>
                            </a>
                            <span v-else class="text-muted">Tác giả không còn tồn tại (#{{ item.authorId || '?' }})</span>
                          </td>

                          <td>
                            <div>{{ item.price }} xu/lượt đọc</div>
                            <div>{{ item.priceExclusive }} xu/lượt đọc</div>
                          </td>
                          <td>
                            <div>Tổng xu: <span class="text-dark bold">{{ $numberFormat(item.total) }}</span> xu</div>
                            <div>Xu lượt đọc: <span
                                class="text-success bold">{{ $numberFormat(item.totalAmount) }}</span> xu
                            </div>
                            <div>Xu độc quyền: <span
                                class="text-warning bold">{{ $numberFormat(item.totalAmountExclusive) }}</span> xu
                            </div>
                          </td>
                          <td>{{ $formatDateTime2(item.createdAt) }}</td>
                          <td>{{ $formatDateTime2(item.createdAt) }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <!--end::Table-->
                </div>
                <!--end::Card body-->
              </div>
            </div>
          </div>
          <!--end::Container-->
        </div>
        <!--end::Content-->
      </div>
      <!--end::Wrapper-->
    </div>
    <!--end::Page-->
  </div>
</template>
<script>
import requestUtil from "@/utils/request-util";
import AuthorCard from "@/components/commons/AuthorCard.vue";

export default {
  name: "AuthorPayView",
  components: {AuthorCard},
  computed: {},
  data() {
    return {
      selectedDay: '',     // Ngày đang chọn
      last10Days: [],
      items: {
        data: [],
        metaData: {},
      },
      modalShow: false,
      dataForm: {},
      loading: {
        page: false,
        user: false,
      },
    };
  },
  mounted() {
    this.fetchItems();
  },
  created() {
    this.generateLast10Days();
    this.selectedDay = this.last10Days[0]; // Chọn mặc định ngày gần nhất (hôm qua)
  },
  methods: {
    generateLast10Days() {
      const today = new Date();
      const days = [];
      for (let i = 1; i <= 10; i++) {
        const date = new Date(today);
        date.setDate(date.getDate() - i);
        days.push(date.toISOString().split('T')[0]);
      }
      this.last10Days = days;
    },
    async fetchItems() {
      try {
        const response = await requestUtil.get(`/author/pay_view/_admin?day=${this.selectedDay}&sort=total,desc`);
        if (response.status === 200) {
          this.items = response.data;
        }
      } catch (err) {
        this.items = {data: [], metaData: {}};
        this.$notify({
          title: "Không tải được dữ liệu trả xu",
          text: err?.message || "",
          type: "warn",
        });
      }
    },
  },
};
</script>
<style></style>
